import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CategorySlideShow = ({ images, title, type, handleTypeChange }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const navigate = useNavigate();

  // Function to handle type change and navigation
  const handleClick = () => {
    handleTypeChange(type); // Call the handleTypeChange function with the selected type
    navigate('/products'); // Navigate to the products page
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true); // Start fade-out
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(false); // Reset fade after changing the image
      }, 1000); // Wait for the fade-out to complete
    }, 3500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300">
      {/* Slideshow Image with Fade Effect */}
      <button onClick={handleClick}>
        <img
          src={images[currentImageIndex]}
          alt={title}
          className={`w-full h-64 object-cover slideshow-image ${fade ? 'fade-out' : ''}`}
        />
        <div className="p-6">
          <h3 className="text-xl font-semibold mb-2">{title}</h3>
        </div>
      </button>
    </div>
  );
};

export default CategorySlideShow;